import { Helmet } from "react-helmet";
import { MENU_BASE_URL } from "../menu.js";

export const SITE_NAME = "MiQRapp";
export const DEFAULT_DESCRIPTION = "Armá gratis tu menú o catálogo online con fotos y precios, compartilo con un QR que no cambia y actualizalo cuando quieras.";
export const DEFAULT_IMAGE = MENU_BASE_URL + "/og-image.png";

// Título, descripción, link canónico y vista previa para redes de cada página.
// public/index.html trae los mismos tags marcados con data-react-helmet para que
// Helmet los reemplace en vez de duplicarlos.
// path es la ruta canónica ("/", "/preguntas-frecuentes"); sin path no se indexa.
const Seo = ({ title, description = DEFAULT_DESCRIPTION, path, image = DEFAULT_IMAGE, type = "website", noindex, jsonLd }) => {

    const url = path !== undefined ? MENU_BASE_URL + path : undefined;
    const indexable = !noindex && url;

  return (
    <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="robots" content={indexable ? "index, follow, max-image-preview:large" : "noindex, follow"} />
        {indexable && <link rel="canonical" href={url} />}

        <meta property="og:site_name" content={SITE_NAME} />
        <meta property="og:locale" content="es_AR" />
        <meta property="og:type" content={type} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={image} />
        {image === DEFAULT_IMAGE && <meta property="og:image:width" content="1200" />}
        {image === DEFAULT_IMAGE && <meta property="og:image:height" content="630" />}
        {image === DEFAULT_IMAGE && <meta property="og:image:alt" content="MiQRapp: tu menú o catálogo online con tu propio QR" />}
        {url && <meta property="og:url" content={url} />}

        <meta name="twitter:card" content={image === DEFAULT_IMAGE ? "summary_large_image" : "summary"} />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={image} />

        {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  )
}

export default Seo
